export const FontFamilyIds = {
  Alegreya: 'Alegreya',
  AlfaSlabOne: 'AlfaSlabOne',
  AmaticSC: 'AmaticSC',
  Arial: 'Arial',
  ArialBlack: 'ArialBlack',
  Arimo: 'Arimo',
  Arvo: 'Arvo',
  Bitter: 'Bitter',
  ChangaOne: 'ChangaOne',
  CinzelDecorative: 'CinzelDecorative',
  ComicSansMS: 'ComicSansMS',
  Courier: 'Courier',
  CrimsonText: 'CrimsonText',
  DroidSerif: 'DroidSerif',
  FredokaOne: 'FredokaOne',
  FugazOne: 'FugazOne',
  Georgia: 'Georgia',
  Helvetica: 'Helvetica',
  Impact: 'Impact',
  Lato: 'Lato',
  Lemon: 'Lemon',
  LobsterTwo: 'LobsterTwo',
  Lora: 'Lora',
  Lucida: 'Lucida',
  Merriweather: 'Merriweather',
  Montserrat: 'Montserrat',
  NixieOne: 'NixieOne',
  Nunito: 'Nunito',
  OldStandardTT: 'OldStandardTT',
  OpenSans: 'OpenSans',
  Oswald: 'Oswald',
  Palatino: 'Palatino',
  PTSans: 'PTSans',
  PTSerif: 'PTSerif',
  PinyonScript: 'PinyonScript',
  PlayfairDisplay: 'PlayfairDisplay',
  Raleway: 'Raleway',
  Roboto: 'Roboto',
  Satisfy: 'Satisfy',
  SourceSans: 'SourceSans',
  Tahoma: 'Tahoma',
  TimesNewRoman: 'TimesNewRoman',
  TitilliumWeb: 'TitilliumWeb',
  TrebuchetMS: 'TrebuchetMS',
  Ubuntu: 'Ubuntu',
  Vollkorn: 'Vollkorn',
  Verdana: 'Verdana'
};

export const FontStacks = {
  [FontFamilyIds.Alegreya]: 'Alegreya, Georgia, serif',
  [FontFamilyIds.AlfaSlabOne]: 'Alfa Slab One, Arial Black, Rockwell Bold, Georgia Bold, serif',
  [FontFamilyIds.AmaticSC]: 'Amatic SC, Helvetica, Arial, sans-serif',
  [FontFamilyIds.Arial]: 'Arial,Helvetica,sans-serif',
  [FontFamilyIds.ArialBlack]: 'Arial Black,Arial Bold,Gadget,sans-serif',
  [FontFamilyIds.Arimo]: 'Arimo, Helvetica, Arial, sans-serif',
  [FontFamilyIds.Arvo]: 'Arvo, Rockwell, Georgia, serif',
  [FontFamilyIds.Bitter]: 'Bitter, Rockwell, Georgia, serif',
  [FontFamilyIds.ChangaOne]: 'Changa One, Arial Black, Helvetica Bold, Arial Bold, sans-serif',
  [FontFamilyIds.CinzelDecorative]: 'Cinzel Decorative, cursive',
  [FontFamilyIds.ComicSansMS]: 'Comic Sans MS, Comic Sans, Chalkboard, Marker Felt, sans-serif',
  [FontFamilyIds.Courier]: 'Courier, monospace',
  [FontFamilyIds.CrimsonText]: 'Crimson Text, Hoefler Text, Garamond, Georgia, serif',
  [FontFamilyIds.DroidSerif]: 'Droid Serif, Cambria Times, Times New Roman, serif',
  [FontFamilyIds.FredokaOne]: 'Fredoka One, cursive',
  [FontFamilyIds.FugazOne]: 'Fugaz One, cursive',
  [FontFamilyIds.Georgia]: 'Georgia,Times,serif',
  [FontFamilyIds.Helvetica]: 'Helvetica,Arial,sans-serif',
  [FontFamilyIds.Impact]: 'Impact, Franklin Gothic Bold, Arial Black, sans-serif',
  [FontFamilyIds.Lato]: 'Lato, Helvetica, Arial, sans-serif',
  [FontFamilyIds.Lemon]: 'Lemon, cursive',
  [FontFamilyIds.LobsterTwo]: 'Lobster Two, cursive',
  [FontFamilyIds.Lora]: 'Lora, Georgia, serif',
  [FontFamilyIds.Lucida]: 'Lucida Sans Unicode, Lucida Grande, Lucida, sans-serif',
  [FontFamilyIds.Merriweather]: 'Merriweather, Georgia, serif',
  [FontFamilyIds.Montserrat]: 'Montserrat, sans-serif',
  [FontFamilyIds.NixieOne]: 'Nixie One, cursive',
  [FontFamilyIds.Nunito]: 'Nunito, Helvetica, Arial, sans-serif',
  [FontFamilyIds.OldStandardTT]: 'Old Standard TT, serif',
  [FontFamilyIds.OpenSans]: 'Open Sans, Helvetica, Arial, sans-serif',
  [FontFamilyIds.Oswald]: 'Oswald, sans-serif',
  [FontFamilyIds.Palatino]: 'Palatino, Palatino Linotype, Palatino LT STD, Book Antiqua, Georgia, serif',
  [FontFamilyIds.PTSans]: 'PT Sans, sans-serif',
  [FontFamilyIds.PTSerif]: 'PT Serif, Rockwell, Georgia, serif',
  [FontFamilyIds.PinyonScript]: 'Pinyon Script, cursive',
  [FontFamilyIds.PlayfairDisplay]: 'Playfair Display, Cambria, Times, Times New Roman, serif',
  [FontFamilyIds.Raleway]: 'Raleway, sans-serif',
  [FontFamilyIds.Roboto]: 'Roboto, sans-serif',
  [FontFamilyIds.Satisfy]: 'Satisfy, cursive',
  [FontFamilyIds.SourceSans]: 'Source Sans Pro, Helvetica, Arial, sans-serif',
  [FontFamilyIds.Tahoma]: 'Tahoma, Verdana, Segoe, sans-serif',
  [FontFamilyIds.TimesNewRoman]: 'TimesNewRoman,Times New Roman,Times,Georgia,serif',
  [FontFamilyIds.TitilliumWeb]: 'Titillium Web,sans-serif',
  [FontFamilyIds.TrebuchetMS]: 'Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif',
  [FontFamilyIds.Ubuntu]: 'Ubuntu, Helvetica, Arial, sans-serif',
  [FontFamilyIds.Vollkorn]: 'Vollkorn, Palatino, Georgia, serif',
  [FontFamilyIds.Verdana]: 'Verdana, Geneva, sans-serif'
};

export const StandardFontIds = [
  FontFamilyIds.Arial,
  FontFamilyIds.ArialBlack,
  FontFamilyIds.ComicSansMS,
  FontFamilyIds.Courier,
  FontFamilyIds.Georgia,
  FontFamilyIds.Helvetica,
  FontFamilyIds.Impact,
  FontFamilyIds.Lucida,
  FontFamilyIds.Palatino,
  FontFamilyIds.Tahoma,
  FontFamilyIds.TimesNewRoman,
  FontFamilyIds.TrebuchetMS,
  FontFamilyIds.Verdana
];

export const FontFamilyOptions = [
  {
    name: 'StyleFields_FontFamily_Alegreya__resx',
    value: FontFamilyIds.Alegreya
  },
  {
    name: 'StyleFields_FontFamily_AlfaSlabOne__resx',
    value: FontFamilyIds.AlfaSlabOne
  },
  {
    name: 'StyleFields_FontFamily_AmaticSC__resx',
    value: FontFamilyIds.AmaticSC
  },
  {
    name: '_fieldOption_arial__resx',
    value: FontFamilyIds.Arial
  },
  {
    name: '_fieldOption_arialBlack__resx',
    value: FontFamilyIds.ArialBlack
  },
  {
    name: 'StyleFields_FontFamily_Arimo__resx',
    value: FontFamilyIds.Arimo
  },
  {
    name: 'StyleFields_FontFamily_Arvo__resx',
    value: FontFamilyIds.Arvo
  },
  {
    name: 'StyleFields_FontFamily_Bitter__resx',
    value: FontFamilyIds.Bitter
  },
  {
    name: 'StyleFields_FontFamily_ChangaOne__resx',
    value: FontFamilyIds.ChangaOne
  },
  {
    name: '_fieldOption_cinzelDecorative__resx',
    value: FontFamilyIds.CinzelDecorative
  },
  {
    name: 'StyleFields_FontFamily_ComicSansMS__resx',
    value: FontFamilyIds.ComicSansMS
  },
  {
    name: '_fieldOption_courier__resx',
    value: FontFamilyIds.Courier
  },
  {
    name: 'StyleFields_FontFamily_CrimsonText__resx',
    value: FontFamilyIds.CrimsonText
  },
  {
    name: 'StyleFields_FontFamily_DroidSerif__resx',
    value: FontFamilyIds.DroidSerif
  },
  {
    name: '_fieldOption_fredokaOne__resx',
    value: FontFamilyIds.FredokaOne
  },
  {
    name: 'StyleFields_FontFamily_Fugaz__resx',
    value: FontFamilyIds.FugazOne
  },
  {
    name: '_fieldOption_georgia__resx',
    value: FontFamilyIds.Georgia
  },
  {
    name: '_fieldOption_Helvetica__resx',
    value: FontFamilyIds.Helvetica
  },
  {
    name: 'StyleFields_FontFamily_Impact__resx',
    value: FontFamilyIds.Impact
  },
  {
    name: 'StyleFields_FontFamily_Lato__resx',
    value: FontFamilyIds.Lato
  },
  {
    name: 'StyleFields_FontFamily_Lemon__resx',
    value: FontFamilyIds.Lemon
  },
  {
    name: 'StyleFields_FontFamily_LobsterTwo__resx',
    value: FontFamilyIds.LobsterTwo
  },
  {
    name: 'StyleFields_FontFamily_Lora__resx',
    value: FontFamilyIds.Lora
  },
  {
    name: 'StyleFields_FontFamily_Lucida__resx',
    value: FontFamilyIds.Lucida
  },
  {
    name: 'StyleFields_FontFamily_Merriweather__resx',
    value: FontFamilyIds.Merriweather
  },
  {
    name: '_fieldOption_montserrat__resx',
    value: FontFamilyIds.Montserrat
  },
  {
    name: '_fieldOption_nixieOne__resx',
    value: FontFamilyIds.NixieOne
  },
  {
    name: 'StyleFields_FontFamily_Nunito__resx',
    value: FontFamilyIds.Nunito
  },
  {
    name: '_fieldOption_oldStandard__resx',
    value: FontFamilyIds.OldStandardTT
  },
  {
    name: 'StyleFields_FontFamily_OpenSans__resx',
    value: FontFamilyIds.OpenSans
  },
  {
    name: '_fieldOption_oswald__resx',
    value: FontFamilyIds.Oswald
  },
  {
    name: 'StyleFields_FontFamily_Palatino__resx',
    value: FontFamilyIds.Palatino
  },
  {
    name: '_fieldOption_ptSans__resx',
    value: FontFamilyIds.PTSans
  },
  {
    name: 'StyleFields_FontFamily_PTSerif__resx',
    value: FontFamilyIds.PTSerif
  },
  {
    name: 'StyleFields_FontFamily_PinyonScript__resx',
    value: FontFamilyIds.PinyonScript
  },
  {
    name: 'StyleFields_FontFamily_PlayfairDisplay__resx',
    value: FontFamilyIds.PlayfairDisplay
  },
  {
    name: '_fieldOption_raleway__resx',
    value: FontFamilyIds.Raleway
  },
  {
    name: '_fieldOption_roboto__resx',
    value: FontFamilyIds.Roboto
  },
  {
    name: '_fieldOption_satisfy__resx',
    value: FontFamilyIds.Satisfy
  },
  {
    name: 'StyleFields_FontFamily_SourceSans__resx',
    value: FontFamilyIds.SourceSans
  },
  {
    name: 'StyleFields_FontFamily_Tahoma__resx',
    value: FontFamilyIds.Tahoma
  },
  {
    name: '_fieldOption_timesNewRoman__resx',
    value: FontFamilyIds.TimesNewRoman
  },
  {
    name: '_fieldOption_titilliumWeb__resx',
    value: FontFamilyIds.TitilliumWeb
  },
  {
    name: 'StyleFields_FontFamily_TrebuchetMS__resx',
    value: FontFamilyIds.TrebuchetMS
  },
  {
    name: 'StyleFields_FontFamily_Ubuntu__resx',
    value: FontFamilyIds.Ubuntu
  },
  {
    name: 'StyleFields_FontFamily_Vollkorn__resx',
    value: FontFamilyIds.Vollkorn
  },
  {
    name: 'StyleFields_FontFamily_Verdana__resx',
    value: FontFamilyIds.Verdana
  }
];
